import { CONTRACTDIVISIONS, CONTRACTDIVISIONS_ERROR, CONTRACTDIVISIONS_SUCCESS } from './ContractDivisions.actions'

const initialState = {
  data: { Assets: {}, Services: {}, OtherCat: {}, Inm: {}, Time: {}, OtherEj: {} },
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Contract Division's reducer.
 */
const contractDivisionsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CONTRACTDIVISIONS: {
      return { ...state, fetching: true }
    }
    case CONTRACTDIVISIONS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case CONTRACTDIVISIONS_ERROR: {
      return { ...state, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default contractDivisionsReducer
